import styled from 'styled-components';
import { Input } from '@mui/material';

// eslint-disable-next-line import/prefer-default-export
export const StyledInput = styled(Input)`
  width: 100%;
  padding: 0 .5rem;
`;
